import React from "react"
import { browserHistory } from "react-router"
import { TextField, RaisedButton } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import * as api from "../../api"
import * as appStateActions from "../../actions/AppStateActions"
import NoMatch from "../NoMatch"
import PasswordField from "../../components/common/PasswordField"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import { IAccountManagerFESettings } from "../../models"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {
  params: any
}
interface IState {
  password: string
  validPassword: boolean
  passwordErrorText: string
  confirmPassword: string
  confirmPasswordErrorText: string
  requestAttempted: boolean
  isPageValidate: boolean
  loading: boolean
  frontEndSettings: IAccountManagerFESettings
}

export default class ResetPassword extends React.Component<IProps, IState> {
  constructor(props, context) {
    super(props, context)
    this.state = {
      password: "",
      validPassword: false,
      passwordErrorText: "",
      confirmPassword: "",
      confirmPasswordErrorText: "",
      requestAttempted: false,
      isPageValidate: false,
      loading: true,
      frontEndSettings: null,
    }
    autobind(this)
  }

  componentWillMount() {
    AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
    appStateActions.getFrontEndSettings()
  }

  componentDidMount() {
    document.title = `Reset Password | ${strings.Findd_Grandd_Central}`
    this.checkPageValidate()
  }

  frontEndSettingsChange() {
    this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
  }

  checkPageValidate() {
    api.checkResetPageValide(this.props.params.token).then(res => {
      this.setState({ isPageValidate: res.data, loading: false })
    })
  }

  handleRequestResetPassword() {
    this.setState({ requestAttempted: true })
    if (!this.checkValidate()) return
    appStateActions.resetPassword(this.props.params.token, this.state.password)
    browserHistory.push("/login")
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.password) {
      this.setState({ passwordErrorText: strings.Password_required })
      isValidate = false
    } else {
      this.setState({ passwordErrorText: "" })
    }

    if (!this.state.confirmPassword) {
      this.setState({
        confirmPasswordErrorText: strings.Password_Confirm_Required
      })
      isValidate = false
    } else {
      this.setState({ confirmPasswordErrorText: "" })
    }

    if (this.state.password && this.state.confirmPassword && this.state.password !== this.state.confirmPassword) {
      this.setState({ passwordErrorText: strings.Passwords_must_match })
      isValidate = false
    }

    if (!this.state.validPassword) {
      isValidate = false
    }
    return isValidate
  }

  render() {
    if (!this.state.frontEndSettings) {
      return (
        <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%" }}><div style={{ padding: 20 }}>{strings.loading}</div></div>
      )
    }

    if (this.state.loading) return null
    if (!this.state.loading && !this.state.isPageValidate) return <NoMatch />
    const resetPassword = (
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 21, marginTop: 24, fontWeight: 500 }}>
          {strings.Please_enter_your_new_password}
        </div>
        <div>
          <PasswordField
            password={this.state.password}
            disabled={!this.state.isPageValidate}
            errorPassword={this.state.passwordErrorText}
            handleChange={(password, validPassword) => this.setState({ password, validPassword }, () => this.state.requestAttempted && this.checkValidate())}
            handleSave={(password, validPassword) => this.setState({ password, validPassword }, () => this.handleRequestResetPassword())}
          />
          <TextField
            floatingLabelText={strings.Password_Confirmation}
            value={this.state.confirmPassword}
            type="password"
            onChange={e => this.setState({ confirmPassword: e.target.value }, () => this.state.requestAttempted && this.checkValidate())}
            onKeyUp={event => event.keyCode === 13 && this.handleRequestResetPassword()}
            errorText={this.state.confirmPasswordErrorText}
            style={{ marginRight: 20, width: "100%", position: "relative" }}
            errorStyle={{ position: "absolute", left: 0, right: 0, bottom: -12, textAlign: "left" }}
            disabled={!this.state.isPageValidate}
          />
          <div
            id="ForgotPassword"
            style={{ marginTop: 10, textAlign: "right", color: "rgba(0,0,0,0.4)", cursor: "pointer" }}
            onClick={() => browserHistory.push("/login")}
          >
            {strings.Back_to_sign_in}
          </div>
          <RaisedButton label={strings.Set_New_Password} onClick={this.handleRequestResetPassword} secondary style={{ marginTop: 20 }} disabled={!this.state.isPageValidate} />
        </div>
      </div>
    )
    return (
      <RegistrationLayout
        leftContainer={resetPassword}
        rightContainer={<img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/password-graphic.png" style={{ position: "absolute", top: "30%", width: "50%", left: "25%" }} />}
        loading={null}
        frontEndSettings={this.state.frontEndSettings}
      />
    )
  }
}
